/**
 * Pause the execution of the code.
 * @param {number} ms The number of milliseconds to pause.
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}